import { Link, Route } from "react-router-dom";
import Layout from "./Layout";
import Dashboard from "./Dashboard";
import Employees from "./pages/Employees";
import EmployeeChanges from "./pages/EmployeeChanges";
import JobPositions from "./pages/JobPositions";
import JobPositionChanges from "./pages/JobPositionChanges";
import Departments from "./pages/Departements";
import DepartmentChanges from "./pages/DepartmentChanges";
import { loadEmployee, loadEmployees } from "./apis/employeeAPI";
import { loadJobPosition, loadJobPositions } from "./apis/JobPositionAPI";
import { loadDepartment, loadDepartments } from "./apis/departmentAPI";


const mainRouter = () => (
  <Route path="/employee-app" element={<Layout />} handle={{ crumb: () => <Link to={'/sales'}>Overview</Link>}}>
    <Route index element={<Employees />} loader={loadEmployees} />
    <Route path="employees" element={<Employees />} loader={loadEmployees} />
    <Route path="employees/:action" element={<EmployeeChanges />} loader={params => loadEmployee(params.params.action)} />
    <Route path="job-positions" element={<JobPositions />} loader={loadJobPositions} />
    <Route path="job-positions/:action" element={<JobPositionChanges />} loader={params => loadJobPosition(params.params.action)} />
    <Route path="departments" element={<Departments />} loader={loadDepartments} />
    <Route path="departments/:action" element={<DepartmentChanges />} loader={params => loadDepartment(params.params.action)} />
  </Route>
);


export default mainRouter;